export default __webpack_public_path__ + "static/media/leboncoin.92ac976b.png";